import React from "react";

import Button from "./Button";

import SingleInput from "./formComponents/SingleInput";
import TextArea from "./formComponents/TextArea";
import SubmitMessage from "./formComponents/SubmitMessage";
import RadioInput from "./formComponents/RadioInput";

import "./Contact.css";

class Contact extends React.Component {
  constructor() {
    super();
    this.state = {
      name: "",
      email: "",
      message: "",
      emailError: "Invalid email",
      nameError: "Invalid name",
      messageError: "Invalid message",
      validateEmail: null,
      validateName: null,
      validateMessage: null,
      submitMessage: false,
      sent: true
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.commonValidate = this.commonValidate.bind(this);
    this.validateHelper = this.validateHelper.bind(this);
  }

  componentWillMount() {}

  handleFormSubmit(e) {
    e.preventDefault();
    const formPayload = {
        name: this.state.name,
        email: this.state.email,
        message: this.state.message
      },
      errorMessages = {
        emailError: "Invalid email",
        nameError: "Invalid name",
        messageError: "Invalid message"
      };

    for (let value in formPayload) {
      let stateKey = value + "Error";
      if (formPayload[value].length === 0) {
        errorMessages[stateKey] = "You forgot to enter your " + value;
      } else {
        errorMessages[stateKey] = "Invalid " + value;
      }
      this.setState(errorMessages);
    }

    let validName = this.validateHelper(
        this.commonValidate(formPayload.name),
        "validateName"
      ),
      validEmail = this.validateHelper(
        this.validateEmail(formPayload.email),
        "validateEmail"
      ),
      validMessage = this.validateHelper(
        this.commonValidate(formPayload.message),
        "validateMessage"
      );

    if (validName && validEmail && validMessage) {
      this.setState({
        validateEmail: true,
        validateName: true,
        validatePhone: true,
        validateMessage: true,
        validateAttending: true,
        submitMessage: true
      });

      // Whoop whoop - send the data
      fetch("./mail.php", {
        method: "POST",
        headers: {
          Accept:
            "application/json, application/xml, text/plain, text/html, *.*"
        },
        body: JSON.stringify(formPayload)
      })
        .then(response => {
          if (response.status === 200) {
            setTimeout(
              function() {
                this.setState({ submitMessage: false });
              }.bind(this),
              5000
            ); // wait 5 seconds, then reset to false

            this.handleClearForm(e);
          } else {
            this.setState({ sent: false });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  validateHelper(inputCheck, inputType) {
    if (!inputCheck) {
      this.setState({ [inputType]: false });
      return false;
    } else {
      this.setState({ [inputType]: true });
      return true;
    }
  }

  handleClearForm(e) {
    this.setState({
      name: "",
      email: "",
      message: ""
    });
  }

  handleNameChange(e) {
    this.setState({ validateName: null });
    const name = e.target.value;
    // run validation

    this.commonValidate(name);

    this.setState({ name: name });
  }

  handleEmailChange(e) {
    this.setState({ validateEmail: null });
    const email = e.target.value;
    // run validation

    this.validateEmail(email);

    this.setState({ email: email });
  }

  handleMessageChange(e) {
    this.setState({ validateMessage: null });
    const message = e.target.value;
    // run validation

    this.commonValidate(message);

    this.setState({ message: message });
  }

  validateEmail(value) {
    // regex from http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value);
  }

  commonValidate(value) {
    if (value.length === 0) return false;
    //prevent script injection https://github.com/google/caja/wiki/CajaWhitelists
    const tagBody = "(?:[^\"'>]|\"[^\"]*\"|'[^']*')*";

    const tagOrComment = new RegExp(
      "<(?:" +
        // Comment body.
        "!--(?:(?:-*[^->])*--+|-?)" +
        // Special "raw text" elements whose content should be elided.
        "|script\\b" +
        tagBody +
        ">[\\s\\S]*?</script\\s*" +
        "|style\\b" +
        tagBody +
        ">[\\s\\S]*?</style\\s*" +
        // Regular name
        "|/?[a-z]" +
        tagBody +
        ")>",
      "gi"
    );

    return !tagOrComment.test(value);
  }

  render() {
    return (
      <form
        className="Component-container form small-12 columns"
        onSubmit={this.handleFormSubmit}
      >
        <h2 className="form__heading">Contact</h2>
        <p className="form__paragraph text-left">
          For commission enquiries, projects, or information about art work, say hello in the form below or alternatively email me direct at <a href="mailto:rob@robleeart.co.uk">rob@robleeart.co.uk</a>
        </p>
        <div className="input-row">
          <div className="box">
            <SingleInput
              inputType={"text"}
              title={"Name"}
              name={"name"}
              controlFunc={this.handleNameChange}
              content={this.state.name}
              errorMessage={this.state.nameError}
              valid={this.commonValidate(this.state.name)}
              validate={this.state.validateName}
            />
          </div>

          <div className="box">
            <SingleInput
              inputType={"email"}
              title={"Email"}
              name={"email"}
              controlFunc={this.handleEmailChange}
              content={this.state.email}
              errorMessage={this.state.emailError}
              valid={this.commonValidate(this.state.email)}
              validate={this.state.validateEmail}
            />
          </div>
        </div>

        <div className="box--textarea">
          <div className="box">
            <TextArea
              title={"Message"}
              resize={false}
              content={this.state.message}
              name={"message"}
              controlFunc={this.handleMessageChange}
              errorMessage={this.state.messageError}
              valid={this.commonValidate(this.state.message)}
              validate={this.state.validateMessage}
            />

            <div className="submit">
              <Button
                buttonText="Submit form"
                buttonType="submit"
                buttonLink="#"
              />
            </div>
          </div>
        </div>
        <SubmitMessage show={this.state.submitMessage} sent={this.state.sent} />
      </form>
    );
  }
}

Contact.propTypes = {};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js